import styled from 'styled-components'
import { ArrowDownIcon } from '@velasca/icons/arrow-down'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 1rem 1.2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: 769px) {
    padding: 2rem 3rem;
  }
`

export const CurrencyList = styled.ul`
  padding: 0;
  list-style-type: none;
  column-count: 1;
  column-width: 100%;
`

export const CurrencyItem = styled.li`
  display: flex;
  gap: 1rem;
  padding: 0.5rem 0;
  align-items: center;
  font-size: 1.4rem;
  font-weight: 400;

  & span {
    font-size: 1.4rem;
  }

  & strong {
    font-weight: 500;
  }
`

export const CurrencyFlag = styled.div`
  width 1.4rem;
  height: 1.2rem;
`

export const Subtitle = styled.li`
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: 0;
  margin: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`

export const CloseIcon = styled(ArrowDownIcon)`
  width: 1rem;
  height: 1rem;
`
